import { Component, Input } from '@angular/core';
import { TpmItemsProcessorService } from '../../../../services/tpm-items-processor.service';

@Component({
  selector: 'app-work-list-items',
  standalone: false,
  templateUrl: './work-list-items.component.html',
  styleUrl: './work-list-items.component.css',
})
export class WorkListItemsComponent {
  @Input() workItem: any;
  @Input() title: string = 'Items to be picked';

  constructor(private readonly tpmItemsProcessorService: TpmItemsProcessorService){}
  
  getShortProductName(productName: string | null): string {
    return this.tpmItemsProcessorService.extractProductName(productName ?? '');
  }
}
